import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

import { BagContinueToCheckoutCta } from '../../Ctas/BagContinueToCheckoutCta';

// ─────────────────────────────────────────────────────────────────────────────

export const BagGroupOrderFooter = (props: Props) => {
  const { isDisabled, onPress } = props;

  const { formatMessage } = useIntl();
  const viewMenuCta = formatMessage(messages.viewMenu);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <View style={styles.noticeContainer}>
        <BodyText style={styles.notice} sizeMatch={['14']}>
          <FormattedMessage {...messages.notice} />
        </BodyText>
      </View>

      <BagContinueToCheckoutCta
        accessibilityLabel={viewMenuCta}
        cta={viewMenuCta}
        isDisabled={isDisabled}
        onPress={onPress}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  notice: {
    defaultMessage: 'FYI - All items will be locked once owner proceeds to checkout.',
    description: 'Bag | Group order | Participant checkout notice',
  },
  viewMenu: {
    defaultMessage: 'View menu',
    description: 'Bag | Group order | Participant view menu CTA',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: theme.spacing['2'],
  },
  noticeContainer: {
    alignSelf: 'center',
    backgroundColor: theme.colors.CREAM,
    borderRadius: theme.radius.large,
    boxShadow: 'rgb(248, 247, 240) 0 2px 20px 5px',
    padding: theme.spacing['3'],
  },
  notice: {
    color: theme.colors.CHARCOAL,
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
